import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
import DashboardHeading from '../commonFiles/DashboardHeading';
import DashboardFooter from '../commonFiles/DashboardFooter';
import DashboardPageNotFound from '../commonFiles/DashboardPageNotFound';
import AdminNavbar from './AdminNavbar';
import Calendar from './Calendar';
import ViewEmployee from './ViewEmployee';
import FreeConsultation from './FreeConsultation';
import ScheduleConsultation from './ScheduleConsultation';
import PartTimeEmployee from './PartTimeEmployee';
import ViewPartTimeEmployee from './ViewPartTimeEmployee';
import ViewAllClients from './ViewAllClients';
import ViewEvents from './ViewEvents';
import ViewLeave from './ViewLeave';
import ViewHoliday from './ViewHoliday';
import ViewEmployeeProfile from './ViewEmployeeProfile';

class AdminInfo extends Component {
  constructor() {
    super();
    this.state = {
        app_view:'',
    };
  }

  check_user_login_not(){
    let cutThis = this;
    var web_token = $('#web_token').val();
     var body = new FormData();
     body.append('web_token',web_token);
     body.append('function','check_admin_session');
     var url      = '';
     if(window.location.host ==="localhost:3000"){
       url = "http://localhost/bylawsindia/php/admin_free_consultation_url.php";
     }else{
       url = "/php/admin_free_consultation_url.php";
     }
     axios({
          method: 'POST',
          url: url,
          data: body
      })
      .then(function (res) {
        var data = res.data;
        if(data==0){
          window.location.href = '/';
        }
      })
      .catch(function (error) {
          console.log(error);
      });
  }
  componentDidMount() {
    this.open_selected_page('calendar');
  }

  open_selected_page(list_name){
    $('.nav_link_p').removeClass('nav_active_dash');
    $('#'+list_name).addClass('nav_active_dash');
    this.check_user_login_not();
    var app_view = '';
    switch(list_name) {
      case 'calendar':
        app_view = <Calendar/>;
      break;
      case 'addUser':
        app_view = <ViewEmployee/>;
      break;
      case 'free_consultation':
         app_view = <FreeConsultation/>;
       break;
       case 'schedule_consultation':
          app_view = <ScheduleConsultation/>;
       break;
       case 'view_part_time_employee':
          app_view = <ViewPartTimeEmployee/>;
       break;
       case 'all_clients':
           app_view = <ViewAllClients/>;
       break;
       case 'view_event':
          app_view = <ViewEvents/>;
       break;
       case 'view_leave':
           app_view = <ViewLeave/>;
       break;
       case 'view_holiday':
           app_view = <ViewHoliday/>;
       break;
       case 'view_profile':
           app_view = <ViewEmployeeProfile/>;
       break;
       default:
          app_view = <DashboardPageNotFound/>;
    }
    this.setState({app_view});
  }

  render() {
    return (
        <>
        <AdminNavbar open_menu_page={this.open_selected_page.bind(this)}/>
        <main role="main" className="col-md-9 ml-sm-auto col-lg-10 main" id="dashboard_right_card">
            {this.state.app_view}
            <DashboardFooter/>
        </main>
        </>
    );
  }
}

export default AdminInfo;
